// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/cron_query.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { OfflineQueryWriteTo, UnloadResolverSpec } from "../../common/v1/offline_query_pb";
import { file_chalk_common_v1_offline_query } from "../../common/v1/offline_query_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";
import type { ResourceRequests } from "../../common/v1/resources_pb";

/**
 * Describes the file chalk/artifacts/v1/cron_query.proto.
 */
export const file_chalk_artifacts_v1_cron_query: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_common_v1_offline_query, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.artifacts.v1.RecomputeSettings
 */
export type RecomputeSettings = Message<"chalk.artifacts.v1.RecomputeSettings"> & {
  /**
   * @generated from field: repeated string feature_fqns = 1;
   */
  featureFqns: string[];

  /**
   * @generated from field: bool all_features = 2;
   */
  allFeatures: boolean;
};

/**
 * Describes the message chalk.artifacts.v1.RecomputeSettings.
 * Use `create(RecomputeSettingsSchema)` to create a new message.
 */
export const RecomputeSettingsSchema: GenMessage<RecomputeSettings> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_cron_query, 0);

/**
 * @generated from message chalk.artifacts.v1.CronQuery
 */
export type CronQuery = Message<"chalk.artifacts.v1.CronQuery"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string cron = 2;
   */
  cron: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * @generated from field: repeated string output = 4;
   */
  output: string[];

  /**
   * @generated from field: optional int64 max_samples = 5;
   */
  maxSamples?: bigint;

  /**
   * @generated from field: chalk.artifacts.v1.RecomputeSettings recompute = 6;
   */
  recompute?: RecomputeSettings;

  /**
   * @generated from field: google.protobuf.Timestamp lower_bound = 7;
   */
  lowerBound?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp upper_bound = 8;
   */
  upperBound?: Timestamp;

  /**
   * @generated from field: repeated string tags = 9;
   */
  tags: string[];

  /**
   * @generated from field: repeated string required_resolver_tags = 10;
   */
  requiredResolverTags: string[];

  /**
   * @generated from field: bool store_online = 11;
   */
  storeOnline: boolean;

  /**
   * @generated from field: bool store_offline = 12;
   */
  storeOffline: boolean;

  /**
   * @generated from field: repeated string incremental_sources = 13;
   */
  incrementalSources: string[];

  /**
   * @generated from field: optional string resource_group = 14;
   */
  resourceGroup?: string;

  /**
   * @generated from field: map<string, string> planner_options = 15;
   */
  plannerOptions: { [key: string]: string };

  /**
   * @generated from field: optional google.protobuf.Duration completion_deadline = 16;
   */
  completionDeadline?: Duration;

  /**
   * @generated from field: optional int32 num_shards = 17;
   */
  numShards?: number;

  /**
   * @generated from field: optional int32 num_workers = 18;
   */
  numWorkers?: number;

  /**
   * @generated from field: optional string input_sql = 19;
   */
  inputSql?: string;

  /**
   * @generated from field: repeated chalk.common.v1.UnloadResolverSpec unload_resolvers = 20;
   */
  unloadResolvers: UnloadResolverSpec[];

  /**
   * @generated from field: optional int32 max_retries = 21;
   */
  maxRetries?: number;

  /**
   * @generated from field: optional chalk.common.v1.ResourceRequests resources = 22;
   */
  resources?: ResourceRequests;

  /**
   * @generated from field: optional string environment_override = 23;
   */
  environmentOverride?: string;

  /**
   * Name of the dataset that recurring runs write to. Carried so the
   * metadata store can persist the same CronQuerySchedule.dataset_name
   * column the legacy GraphQL apply path wrote.
   *
   * @generated from field: optional string dataset_name = 24;
   */
  datasetName?: string;

  /**
   * Optional destination each run's output rows are written to directly
   * (e.g. a storage URI usable as a velox TableWriteNode target), in
   * addition to online/offline store persistence.
   *
   * @generated from field: optional chalk.common.v1.OfflineQueryWriteTo write_to = 25;
   */
  writeTo?: OfflineQueryWriteTo;

  /**
   * ISO datetime or chalk duration prefixed with "delta:" (e.g. "delta:-7d"); when set, takes
   * precedence over lower_bound/upper_bound and is resolved at run time.
   *
   * @generated from field: optional string observed_at_lower_bound = 26;
   */
  observedAtLowerBound?: string;

  /**
   * @generated from field: optional string observed_at_upper_bound = 27;
   */
  observedAtUpperBound?: string;

  /**
   * Data quality checks declared with `ScheduledQuery(...).with_checks(...)`, one serialized
   * `DqmCheckSpec` per entry -- the same JSON the `CHALK_DQM_CHECK_SPECS` environment variable
   * carries, so both surfaces feed one parser.
   *
   * Deliberately JSON rather than a typed message. A check's assertions carry fields that only
   * newer chalkpy versions know about (`kind`, `source_sql`, `preview_sql`), and the engine's
   * parser ignores the ones it does not recognize -- so a customer on a newer chalkpy keeps
   * working against an older engine, just without the extra reporting. Modeling it in proto
   * would turn each new check kind into a coordinated rollout.
   *
   * This is what makes `with_checks` reach the engine at all: the engine builds its graph from
   * a serialized artifact and never executes the customer's Python, so the checks have to
   * travel as data alongside every other ScheduledQuery field.
   *
   * @generated from field: repeated string data_quality_check_specs = 28;
   */
  dataQualityCheckSpecs: string[];

  /**
   * Environment variables applied to each recurring offline query run.
   *
   * @generated from field: map<string, string> env_overrides = 29;
   */
  envOverrides: { [key: string]: string };

  /**
   * When set, overrides the server-side scheduled-query metaplanner rollout flags for this query.
   *
   * @generated from field: optional bool use_metaplanner = 30;
   */
  useMetaplanner?: boolean;
};

/**
 * Describes the message chalk.artifacts.v1.CronQuery.
 * Use `create(CronQuerySchema)` to create a new message.
 */
export const CronQuerySchema: GenMessage<CronQuery> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_cron_query, 1);

